import {
  BRAND_OFFERS_ADMIN_AUTH_CHANGED_EVENT,
  BRAND_OFFERS_ADMIN_TOKEN_STORAGE_KEY,
  BRAND_OFFERS_ADMIN_USER_STORAGE_KEY,
} from './BrandOffersAdminAuthContext.constants';

export function readBrandOffersAdminToken(): string | null {
  return localStorage.getItem(BRAND_OFFERS_ADMIN_TOKEN_STORAGE_KEY);
}

export function readBrandOffersAdminDisplayUser(): string {
  return sessionStorage.getItem(BRAND_OFFERS_ADMIN_USER_STORAGE_KEY) ?? '';
}

export interface WriteBrandOffersAdminSessionInput {
  token: string;
  displayUser: string;
}

export function writeBrandOffersAdminSession({
  token,
  displayUser,
}: WriteBrandOffersAdminSessionInput): void {
  localStorage.setItem(BRAND_OFFERS_ADMIN_TOKEN_STORAGE_KEY, token);
  sessionStorage.setItem(BRAND_OFFERS_ADMIN_USER_STORAGE_KEY, displayUser);
}

export function clearBrandOffersAdminSession(): void {
  localStorage.removeItem(BRAND_OFFERS_ADMIN_TOKEN_STORAGE_KEY);
  sessionStorage.removeItem(BRAND_OFFERS_ADMIN_USER_STORAGE_KEY);
}

export function notifyBrandOffersAdminAuthChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(BRAND_OFFERS_ADMIN_AUTH_CHANGED_EVENT));
}
